import React from "react";
import { Link } from "react-scroll";
import sandeepResume from "../assets/img/Sandeep-Yadav-CV.pdf";
// import woman image
import sandeep from "../assets/img/profile-pic.png";

const Hero = () => {
  return (
    <section
      id="home"
      className="lg:h-[100vh] flex items-center bg-black py-32 lg:py-0 overflow-hidden "
    >
      <div className="container mx-auto h-full mt-20">
        <div className="flex flex-col-reverse lg:flex-row items-center h-full pt-8 sm:flex-col-reverse">
          <div className="flex-1 flex flex-col items-center lg:items-start">
            <p className="text-lg text-accent text-md mb-[22px]">
              Hey, I'm Sandeep Yadav! 👋
            </p>
            <h1 className="text-4xl leading-[44px] md:text-5xl md:leading-tight lg:text-7xl lg:leading-[1.2] font-bold md:tracking-[-2px]">
              I Build & Design <br /> Web Interfaces.
            </h1>
            <p className="pt-4 pb-8 md:pt-6 md:pb-12 max-w-[480px] text-lg text-center lg:text-left">
              Results-driven Full Stack Developer with 2.5 years of experience and
              a proven track record in building scalable web and software
              applications. Proficient in the MERN (MongoDB, Express.js, React,
              Node.js) stack, as well as PostgreSQL, Fastify, TypeScript, and
              Next.js. Experienced in developing key services from the ground
              up, with a demonstrated ability to lead projects, integrate
              third-party APIs, and enhance user experience through innovative
              solutions.
              <br />
              Let's build something unique together.
            </p>
            <div className="grid gap-2">
              <a
                href={sandeepResume}
                target="_blank"
                download=""
                rel="noreferrer"
              >
                <button
                  onClick={() =>
                    window.open(
                      "https://drive.google.com/file/d/1PN2PwpO4-MVUMXE_NXQxlMV6e3RqGXy1/view?usp=sharing",
                      "_blank"
                    )
                  }
                  className="btn mb-10 btn-md bg-accent hover:bg-secondary-hover md:btn-lg transition-all m-auto"
                >
                  Resume
                </button>
              </a>
            </div>
          </div>
          <div className="top lg:flex flex-1 justify-end items-end h-full">
            <img
              style={{ borderRadius: "50%", width: "350px", margin: "auto" }}
              src={sandeep}
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
